import Size from "./Size";

export enum PageTypes {
  roomplan = "roomplan", // no itx
  floorplan = "floorplan", // no itx
  consumerlist = "consumerlist", // no itx
  scenelist = "scenelist", // no itx
  multiplexerlist = "multiplexerlist", // no itx
  //actorlist = "actorlist", // no itx
  actorinstalationslist = "actorinstalationslist", // no itx
  terminallist = "terminallist", // no itx
  buttonlist = "buttonlist", // no itx
  addressList = "adressList", // no itx
  partsList = "partsList", // no itx
  pricePartsList = "pricePartsList", // no itx
  coverPage = "coverPage", // no itx
  fuselist = "fuselist", // no itx
  //  cabletypelist = "cabletypelist", // no itx
  cablepullList = "cablepullList", // no itx
  cabinetPartList = "cabinetPartList", // no itx
  cableroutingList = "cableroutingList", // no itx
  roomplanPdf = "roomplanPdf", // no itx
  floorplanPdf = "floorplanPdf", // no itx
  pdf = "pdf", // no itx
  roombook = "roombook", // no itx
  projectstatistic = "projectstatistic", // no itx
}
export type PageTypeInfo = {
  isList: boolean;
  calcMinZoom: boolean;
};
export function pageTypeInfo(pageType: PageTypes) {
  switch (pageType) {
    case PageTypes.roomplan:
    case PageTypes.floorplan:
      return {
        isList: false,
        calcMinZoom: true,
        warningPageBehind: false,
      };
    case PageTypes.actorinstalationslist:
    case PageTypes.cablepullList:
    case PageTypes.terminallist:
    case PageTypes.cabinetPartList:
    case PageTypes.fuselist:
    case PageTypes.partsList:
    case PageTypes.pricePartsList:
    case PageTypes.cableroutingList:
      return {
        isList: true,
        calcMinZoom: true,
        warningPageBehind: true,
      };
    case PageTypes.consumerlist:
    case PageTypes.scenelist:
    // case PageTypes.actorlist:
    case PageTypes.buttonlist:
    case PageTypes.addressList:
    //case PageTypes.cabletypelist:
    case PageTypes.multiplexerlist:
    case PageTypes.roomplanPdf:
    case PageTypes.floorplanPdf:
    case PageTypes.roombook:
    case PageTypes.projectstatistic:
      return {
        isList: true,
        calcMinZoom: true,
        warningPageBehind: false,
      };

    case PageTypes.coverPage:
      return {
        isList: false,
        calcMinZoom: false,
        warningPageBehind: false,
      };
    case PageTypes.pdf:
      return {
        isList: false,
        calcMinZoom: false,
        warningPageBehind: false,
      };
  }

  console.error("unbekannter pageType");
}

//
// Size in cm

export const PagePrintBorders = {
  Left: 1,
  Right: 1,
  Top: 1,
  Bottom: 1,
};

export const pageSizeA4 = new Size(21, 29.7);

export const pageSizeA4Landscape = new Size(29.7, 21);

export const pageSizeA3 = new Size(29.7, 42);
